/* eslint-disable max-len, indent, sonarjs/no-duplicate-string */

const hasContexts = (contexts: Array<string>) => contexts.every(context => window.contexts.includes(context));

import widgetsMgr from 'widgets/widgetsMgr';

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['cart', 'paypal']),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'cart.paypal.ext' */ './widgets/cart/PayPalCartBaseButtonExt').then(d => d.default),
            import(/* webpackChunkName: 'cart.paypal.ext' */ './widgets/cart/PayPalCartButtonExt').then(d => d.default),
            import(/* webpackChunkName: 'cart.paypal.ext' */ './widgets/common/PayPalButtonCleanMixin').then(d => d.default)
        ]).then(deps => {
            const [PayPalCartBaseButtonExt, PayPalCartButtonExt, PayPalButtonCleanMixin] = deps;

            return {
                listId: 'cart.paypal.ext',
                widgetsDefinition: () => [
                    ['paypalCartButton', PayPalCartBaseButtonExt, 'paypalCartButton'],
                    ['paypalCartButton', PayPalCartButtonExt, 'paypalCartButton'],
                    ['paypalCartButton', PayPalButtonCleanMixin, 'paypalCartButton'],
                    ['paypalCartBAButton', PayPalCartBaseButtonExt, 'paypalCartBAButton'],
                    ['paypalCartBAButton', PayPalButtonCleanMixin, 'paypalCartBAButton']
                ]
            };
        })
});

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['pdp', 'paypal']),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'pdp.paypal.ext' */ './widgets/common/PayPalBaseButtonExt').then(d => d.default),
            import(/* webpackChunkName: 'pdp.paypal.ext' */ './widgets/cart/PayPalCartBaseButtonExt').then(d => d.default),
            import(/* webpackChunkName: 'pdp.paypal.ext' */ './widgets/cart/PayPalCartButtonExt').then(d => d.default),
            import(/* webpackChunkName: 'pdp.paypal.ext' */ './widgets/pdp/PayPalPDPButton').then(d => d.default),
            import(/* webpackChunkName: 'pdp.paypal.ext' */ './widgets/common/PayPalButtonCleanMixin').then(d => d.default)
        ]).then(deps => {
            const [PayPalBaseButtonExt, PayPalCartBaseButtonExt, PayPalCartButtonExt, PayPalPDPButton, PayPalButtonCleanMixin] = deps;

            return {
                listId: 'pdp.paypal.ext',
                widgetsDefinition: () => [
                    ['paypalPDPButton', PayPalBaseButtonExt],
                    ['paypalPDPButton', PayPalCartBaseButtonExt, 'paypalPDPButton'],
                    ['paypalPDPButton', PayPalCartButtonExt, 'paypalPDPButton'],
                    ['paypalPDPButton', PayPalPDPButton, 'paypalPDPButton'],
                    ['paypalPDPButton', PayPalButtonCleanMixin, 'paypalPDPButton']
                ]
            };
        })
});

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['checkout', 'paypal']),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'checkout.paypal.ext' */ './widgets/common/PayPalBaseButtonExt').then(d => d.default),
            import(/* webpackChunkName: 'checkout.paypal.ext' */ './widgets/cart/PayPalCartBaseButtonExt').then(d => d.default),
            import(/* webpackChunkName: 'checkout.paypal.ext' */ './widgets/cart/PayPalCartButtonExt').then(d => d.default),
            import(/* webpackChunkName: 'checkout.paypal.ext' */ './widgets/cart/PayPalCartStaticButtonExt').then(d => d.default),
            import(/* webpackChunkName: 'checkout.paypal.ext' */ './widgets/common/PayPalButtonCleanMixin').then(d => d.default)
        ]).then(deps => {
            const [PayPalBaseButtonExt, PayPalCartBaseButtonExt, PayPalCartButtonExt, PayPalCartStaticButtonExt, PayPalButtonCleanMixin] = deps;

            return {
                listId: 'checkout.paypal.ext',
                widgetsDefinition: () => [
                    ['paypalCartButton', PayPalBaseButtonExt],
                    ['paypalCartButton', PayPalCartBaseButtonExt, 'paypalCartButton'],
                    ['paypalCartButton', PayPalCartButtonExt, 'paypalCartButton'],
                    ['paypalCartButton', PayPalButtonCleanMixin, 'paypalCartButton'],
                    ['paypalCartStaticButton', PayPalBaseButtonExt],
                    ['paypalCartStaticButton', PayPalCartStaticButtonExt, 'paypalCartStaticButton'],
                    ['paypalBillingButton', PayPalButtonCleanMixin, 'paypalBillingButton'],
                    ['paypalBillingBAButton', PayPalButtonCleanMixin, 'paypalBillingBAButton']
                ]
            };
        })
});
